import { Avatar } from "@mui/material";
import React from "react";

const ReviewCard = ({ rev }) => {
  return (
    <div
      key={rev.id}
      className="text-center bg-back shadow border dark:dark-bg-back w-auto md:w-80 aspect-square my-8 p-8   rounded-lg mx-5  cursor-pointer hover:bg-orange-500 duration-50 flex flex-col justify-center items-center"
    >
      <div className="">
        <div className="my-2">
          <span className="block">{rev.name}</span>
          <Avatar className="mx-auto" alt="Remy Sharp" src={rev.img}>
            {rev.name.toUpperCase()[0]}
          </Avatar>
        </div>
        <div className="h-28 overflow-y-scroll no-scrollbar duration-300 ">
          <p className="text-lg font-bold mb-2  ">
            {[1, 2, 3, 4, 5].map((rating) => (
              <i
                key={rating}
                className={`fa fa-star  mx-1 ${
                  rating <= rev.rating ? "text-yellow-500" : "text-gray-200"
                }`}
                aria-hidden="true"
              ></i>
            ))}
          </p>
          <p>{rev.review}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
